import { defineComponent as S, computed as B, ref as L, watch as V, openBlock as s, createBlock as A, withCtx as E, createElementVNode as o, normalizeStyle as y, normalizeClass as p, unref as m, toDisplayString as n, createElementBlock as i, createCommentVNode as v, Fragment as F, renderList as M } from "vue";
import { useLandingAnimation as q } from "./index127.js";
import z from "./index116.js";
const D = {
  class: "text-3xl font-bold md:text-4xl lg:text-5xl",
  style: { color: "var(--landing-dark)" }
}, N = {
  key: 0,
  class: "mt-4 text-base md:text-lg",
  style: { color: "var(--landing-stats-desc)" }
}, $ = { class: "grid grid-cols-2 gap-0 divide-y divide-[color:var(--landing-stats-divider)] overflow-hidden rounded-2xl border border-[color:var(--landing-stats-divider)] md:grid-cols-4 md:divide-x md:divide-y-0" }, j = {
  class: "text-5xl font-extrabold tabular-nums tracking-tight md:text-6xl",
  style: { color: "var(--landing-primary)" }
}, G = { key: 0 }, H = { key: 1 }, I = {
  class: "mt-3 text-sm font-semibold uppercase tracking-wider md:text-base",
  style: { color: "var(--landing-dark)" }
}, J = {
  key: 0,
  class: "mt-1.5 max-w-[160px] text-xs leading-relaxed md:max-w-[220px] lg:max-w-[260px]",
  style: { color: "var(--landing-stats-subtext)" }
}, Q = /* @__PURE__ */ S({
  __name: "LandingStats",
  props: {
    title: {},
    description: {},
    items: {},
    bg: { default: "white" },
    primary: { default: "var(--base-colors-primary-primary800)" },
    id: {}
  },
  setup(a) {
    const c = a, { el: b, isVisible: d } = q(), f = B(() => ({
      "--landing-stats-card-bg": c.bg === "white" ? "var(--base-colors-neutral-neutral000)" : "var(--base-colors-common-light-gray-f5)",
      "--landing-stats-divider": "var(--base-colors-neutral-neutral200)",
      "--landing-stats-subtext": "var(--base-colors-neutral-neutral500)",
      "--landing-stats-desc": "var(--base-colors-neutral-neutral500)"
    })), u = L(
      c.items.map((e) => String(e.numericTarget ?? e.numericStart ?? e.value))
    );
    function h(e, r) {
      if (r.numericTarget === void 0) return;
      const t = r.numericStart ?? 0, l = r.numericTarget, k = 1e3, _ = performance.now(), g = (w) => {
        const C = w - _, x = Math.min(C / k, 1), T = 1 - Math.pow(1 - x, 3);
        u.value[e] = String(Math.round(t + (l - t) * T)), x < 1 && requestAnimationFrame(g);
      };
      requestAnimationFrame(g);
    }
    return V(d, (e) => {
      e && c.items.forEach((r, t) => {
        setTimeout(() => h(t, r), t * 80);
      });
    }), (e, r) => (s(), A(z, {
      bg: a.bg,
      id: a.id,
      primary: a.primary
    }, {
      default: E(() => [
        o("div", {
          ref_key: "el",
          ref: b,
          style: y(f.value)
        }, [
          o("div", {
            class: p(["mb-12 text-center transition-all duration-700", m(d) ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"])
          }, [
            o("h2", D, n(a.title), 1),
            a.description ? (s(), i("p", N, n(a.description), 1)) : v("", !0)
          ], 2),
          o("div", $, [
            (s(!0), i(F, null, M(a.items, (t, l) => (s(), i("div", {
              key: t.label,
              class: p(["flex flex-col items-center bg-[color:var(--landing-stats-card-bg)] px-4 py-8 text-center md:px-6 md:py-10", m(d) ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"]),
              style: y({
                transition: "opacity 0.7s ease, transform 0.7s ease",
                transitionDelay: m(d) ? `${l * 80}ms` : "0ms"
              })
            }, [
              o("div", j, [
                t.numericTarget !== void 0 ? (s(), i("span", G, n(u.value[l]) + n(t.suffix ?? ""), 1)) : (s(), i("span", H, n(t.value), 1))
              ]),
              o("p", I, n(t.label), 1),
              t.subLabel ? (s(), i("p", J, n(t.subLabel), 1)) : v("", !0)
            ], 6))), 128))
          ])
        ], 4)
      ]),
      _: 1
    }, 8, ["bg", "id", "primary"]));
  }
});
export {
  Q as default
};
